/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import {
    fetchAssets as fleetFetchAssets,
    fetchSingleFleet as fleetFetchSingleFleet,
    fetchFleets as fleetFetchFleets,
    fetchSubFleets as fleetFetchSubFleets
} from '../api/Fleets'
import {fetchAssets as assetFetchAssets} from '../api/Assets'
import {ASSETS_DATA_SET_TYPE} from "../admin/assets/AssetsConst";

export const REQUEST_FLEETS = 'REQUEST_FLEETS';
export const RECEIVE_FLEETS = 'RECEIVE__FLEETS';
export const REQUEST_FLEET = 'REQUEST_FLEET';
export const RECEIVE_FLEET = 'RECEIVE_FLEET';
export const RECEIVE_FLEET_ERROR = 'RECEIVE_FLEET_ERROR';
export const REQUEST_SUB_FLEETS = 'REQUEST_SUB_FLEETS';
export const RECEIVE_SUB_FLEETS = 'RECEIVE_SUB_FLEETS';
export const REQUEST_ASSETS = 'REQUEST_ASSETS';
export const RECEIVE_ASSETS = 'RECEIVE_ASSETS';
export const RECEIVE_ASSETS_FOR_THE_FIRST_TIME = 'RECEIVE_ASSETS_FOR_THE_FIRST_TIME';
export const CLEAR_STATE = 'CLEAR_STATE';


export const fetchFleets = (search, sort) => dispatch => {
    dispatch(requestFleets());
    //all regular fleets we want to fetch are subfleets of Fleets fleet (id=0)
    return fleetFetchFleets(search, sort, undefined, 1).then(
        function (response) {
            dispatch(receiveFleets(response));
        }
    );
}

const requestFleets = () => {
    return {
        type: REQUEST_FLEETS,
    }
}

const receiveFleets = (fleets) => {
    return {
        type: RECEIVE_FLEETS,
        fleets: fleets,
    }
}

export const fetchFleet = (fleetId) => dispatch => {
    dispatch(requestFleet());
    return fleetFetchSingleFleet(fleetId).then(
        function (response) {
            dispatch(receiveFleet(response));
        }
    ).catch(err => {
        dispatch(receiveFleetError(err))
    })
}

const requestFleet = () => {
    return {
        type: REQUEST_FLEET,
    }
}

const receiveFleet = (fleet) => {
    return {
        type: RECEIVE_FLEET,
        fleet: fleet,
    }
}

const receiveFleetError = (err) => {
    return {
        type: RECEIVE_FLEET_ERROR,
        error: err,
    }
}


export const fetchSubFleets = (fleetId, search, sort) => dispatch => {
    dispatch(requestSubFleets());
    return fleetFetchSubFleets(fleetId, search, sort, undefined, 1).then(
        function (response) {
            dispatch(receiveSubFleets(response));
        }
    );
}

const requestSubFleets = () => {
    return {
        type: REQUEST_SUB_FLEETS,
    }
}

const receiveSubFleets = (fleets) => {
    return {
        type: RECEIVE_SUB_FLEETS,
        fleets: fleets,
    }
}


export const fetchAssets = (fleetId, search, sort) => dispatch => {
    dispatch(requestAssets());
    return fleetFetchAssets(fleetId, search, sort).then(
        function (response) {
            dispatch(receiveAssets(response));
        }
    );
}

export const fetchAssetsWithoutFleetForTheFirstTime = (search, sort) => dispatch => {
    dispatch(requestAssets());
    return assetFetchAssets(ASSETS_DATA_SET_TYPE.SHALLOW_WITH_FAULT_COUNT, search, sort).then(
        function (response) {
            dispatch(receiveAssetsForTheFirstTime(response));
        }
    );
}

export const fetchAssetsWithoutFleet = (search, sort) => dispatch => {
    dispatch(requestAssets());
    return assetFetchAssets(ASSETS_DATA_SET_TYPE.SHALLOW_WITH_FAULT_COUNT, search, sort).then(
        function (response) {
            dispatch(receiveAssets(response));
        }
    );
}

const requestAssets = () => {
    return {
        type: REQUEST_ASSETS,
    }
}

const receiveAssets = (assets) => {
    return {
        type: RECEIVE_ASSETS,
        assets: assets,
    }
}

const receiveAssetsForTheFirstTime = (assets) => {
    return {
        type: RECEIVE_ASSETS_FOR_THE_FIRST_TIME,
        assets: assets,
        assetCount: assets.length,
        faultCounts: assets.reduce((a, b) => a + b.faultsCount, 0),
        assetsFaultStatesCount: assets.map(a => {
            return {id: a.id, faultStatesCount: a.faultStatesCount}
        }),
    }
}

export const clearState = () => {
    return {
        type: CLEAR_STATE,
    }
}